import { render, staticRenderFns } from "./DescargaActividadForm.vue?vue&type=template&id=3ce6c340&"
import script from "./DescargaActividadForm.vue?vue&type=script&lang=ts&"
export * from "./DescargaActividadForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3ce6c340', component.options)
    } else {
      api.reload('3ce6c340', component.options)
    }
    module.hot.accept("./DescargaActividadForm.vue?vue&type=template&id=3ce6c340&", function () {
      api.rerender('3ce6c340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/DescargaActividades/crud/DescargaActividadForm.vue"
export default component.exports